import React from 'react';

import Util from '$utilities';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props?.err?.statusCode) || 500;

    let message = '';

    switch (status) {
        case 404:
            message = '404 - Page not found.';
            break;

        default:
            message = 'Sorry, something went wrong.';
    }

    return (
        <main id='main-content'>
            <h1>
                {message}
            </h1>
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
